import type { User } from '@/shared/types/User';

export const NEW_USER_QUIZ_LAUNCH_CUTOFF = '2026-07-10T00:00:00Z';
const NEW_USER_QUIZ_LAUNCH_CUTOFF_MS = new Date(NEW_USER_QUIZ_LAUNCH_CUTOFF).getTime();

const getCreatedAt = (user?: User): null | number => {
  if (!user?.created_date) {
    return null;
  }

  const createdAt = new Date(user.created_date).getTime();

  return Number.isFinite(createdAt) ? createdAt : null;
};

export const isNewUserQuizLaunchUser = (user?: User): boolean => {
  const createdAt = getCreatedAt(user);

  return createdAt !== null && createdAt >= NEW_USER_QUIZ_LAUNCH_CUTOFF_MS;
};

export const isPreNewUserQuizLaunchUser = (user?: User): boolean => {
  const createdAt = getCreatedAt(user);

  return createdAt !== null && createdAt < NEW_USER_QUIZ_LAUNCH_CUTOFF_MS;
};

type NewUserQuizCandidate = {
  hasTrialPlan: boolean;
  isBalanceLoaded: boolean;
  isWhiteLabel: boolean;
  user?: User;
};

export const isNewUserQuizCandidate = ({
  hasTrialPlan,
  isBalanceLoaded,
  isWhiteLabel,
  user,
}: NewUserQuizCandidate): boolean =>
  isBalanceLoaded &&
  hasTrialPlan &&
  !isWhiteLabel &&
  !user?.is_superuser &&
  isNewUserQuizLaunchUser(user);
